import styled from '@emotion/styled';
import { focuses, font, mediaQueries, palette, remCalc } from '../../css';
import { StyledIcon, StyledSvg } from '../../UI/Icon/Icon.css';
import RenderLink from '../../UI/RenderLink/RenderLink';
import SwitchWithLabelBuf from '../../UI/Switch/SwitchWithLabel';

export const SwitchWithLabel = styled(SwitchWithLabelBuf)({
    // ? 5 for padding and 2 for border
    paddingLeft: remCalc(7),
    [mediaQueries.large]: {
        paddingLeft: remCalc(2),
    },
});

const HeaderStyles = styled('div')({
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    textAlign: 'left',
    color: 'inherit',
});

export const PlaylistHeaderContainer = styled('div')({
    color: palette('white'),
    display: 'flex',
    flexDirection: 'column',
    padding: remCalc(10, 0),
    flexShrink: 0,
    [mediaQueries.large]: {
        padding: remCalc(10, 15),
    },
});

export const PlaylistHeaderSeparator = styled('hr')({
    margin: 0,
    width: '100%',
    maxWidth: '100%',
    borderBottom: `1px solid ${palette('primary', 'mainDivider')}`,
    display: 'none',
    [StyledIcon]: {
        display: 'none',
    },
    [mediaQueries.large]: {
        display: 'block',
    },
});

export const HeaderTitleContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
});

const StyledPlaylistHeaderMobile = styled(HeaderStyles)({
    paddingLeft: remCalc(5),
    paddingRight: remCalc(5),
    marginTop: remCalc(0),
    ...focuses.rgaa(':focus', {}),
}).withComponent('button');
const StyledPlaylistHeaderDesktop = HeaderStyles;

const StyledPlaylist = styled('div')(
    () => ({
        fontFamily: font.family.body,
        backgroundColor: palette('primary', 'mainNav'),
        display: 'flex',
        flexDirection: 'column',
    }),
    ({ open }) => {
        const margin = !open ? { marginBottom: 0 } : {};

        return {
            [mediaQueries.largeDown]: {
                padding: remCalc(0, 50, 15),
                [StyledPlaylistHeaderMobile]: {
                    cursor: 'pointer',
                    ...margin,
                },
            },
            [mediaQueries.mediumDown]: {
                padding: remCalc(0, 15, 15),
            },
        };
    },
);

const StyledPlaylistTitleLink = styled(RenderLink)(() => ({
    display: 'block',
    color: palette('white'),

    ':hover': {
        color: palette('grey', 'dark'),
    },

    ...focuses.rgaa(':focus', {
        padding: remCalc(0, 5),
        margin: remCalc(0, -5),
    }),
}));

const StyledPlaylistTitle = styled('h2')(
    () => ({
        margin: 0,
        fontFamily: font.family.header,
        fontSize: font.size.s,
        lineHeight: font.lineHeight.l,
        fontWeight: font.weight.bold,
    }),
    ({ textEllipsis }) =>
        textEllipsis
            ? { fontFamily: font.family.body, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }
            : {},
);

const StyledPlaylistSubtitle = styled('h2')(
    () => ({
        margin: 0,
        fontFamily: font.family.body,
        fontSize: font.size.s,
        lineHeight: font.lineHeight.m,
    }),
    ({ visible }) => (!visible ? { [mediaQueries.largeDown]: { display: 'none' } } : {}),
);

const StyledPlaylistToggle = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',

    [mediaQueries.large]: {
        display: 'none',
    },

    [StyledSvg]: {
        marginTop: remCalc(5),
    },
}));

const StyledPlaylistCounter = styled('div')(() => ({
    fontSize: font.size.s,
    marginRight: remCalc(8),
}));

const StyledPlaylistItem = styled(RenderLink)(
    () => ({
        textDecoration: 'none',
        color: palette('white'),

        display: 'flex',
        alignItems: 'center',

        '.teaser-image': {
            // TODO : replace by CSS in JS component selector (feature/ASG-1133)
            margin: remCalc(10, 0),
            flexShrink: 0,
            flexBasis: remCalc(100),
        },

        ':focus,:hover': {
            backgroundColor: palette('primary', 'mainDivider'),
        },
    }),
    ({ selected }) => (selected ? { backgroundColor: palette('grey', 'xxDark') } : {}),
);

const StyledPlaylistWrapper = styled('div')(
    () => ({
        overflow: 'auto',
        overflowY: 'auto',
        overflowX: 'inherit',
        position: 'relative',

        [StyledPlaylistItem]: {
            color: palette('white'),
        },
    }),
    ({ visible }) => {
        const style = {};

        if (!visible) {
            style[mediaQueries.largeDown] = {
                display: 'none',
            };
        }

        return style;
    },
);

const StyledPlaylistItemNumber = styled('div')(
    () => ({
        fontFamily: font.family.body,
        fontSize: font.size.xs,
        fontWeight: font.weight.regular,
        width: remCalc(50),
        textAlign: 'center',

        flexShrink: 0,
    }),
    () => ({}),
);
const StyledPlaylistItemTitleWrapper = styled('div')(
    () => ({
        padding: remCalc(10, 15),
        fontSize: font.lineHeight.xs,
        lineHeight: font.size.s,
    }),
    () => ({}),
);
const StyledPlaylistItemTitle = styled('div')(() => ({
    fontWeight: font.weight.bold,
}));
const StyledPlaylistItemSubtitle = styled('div')(() => ({
    fontWeight: font.weight.regular,
}));
const StyledPlaylistItemDuration = styled('div')(() => ({
    color: palette('white'),
}));

export {
    StyledPlaylist,
    StyledPlaylistToggle,
    StyledPlaylistCounter,
    StyledPlaylistHeaderMobile,
    StyledPlaylistHeaderDesktop,
    StyledPlaylistTitleLink,
    StyledPlaylistTitle,
    StyledPlaylistSubtitle,
    StyledPlaylistWrapper,
    StyledPlaylistItem,
    StyledPlaylistItemNumber,
    StyledPlaylistItemTitleWrapper,
    StyledPlaylistItemTitle,
    StyledPlaylistItemSubtitle,
    StyledPlaylistItemDuration,
};
